<template>
    <v-data-table
        :headers="headers"
        :items="rentAgreements"
        :items-per-page="-1"
        class="elevation-1"
    >
    </v-data-table>
</template>

<script>
export default {
    name: 'RentAgreements',
    props: {
        rentAgreements: Array,
        headers: Array
    }
};
</script>
